import { FileInfoDto } from '@lmt/shared-types';
import { FormComponentProps } from '@lmt/unicorn-shared/app/components/global-forms/GlobalForms.types';
import {
  VersionsList,
  VersionsListProps,
} from '@lmt/unicorn-shared/app/components/patients/profile/cases/components/documents/VersionsList';
import React, { FC, useCallback } from 'react';

export const VersionsListFormWrapper: FC<
  VersionsListProps & FormComponentProps
> = (props) => {
  const { onVersionClick, closeForm, formId, ...restProps } = props;

  const onClick = useCallback(
    (file: FileInfoDto) => {
      const result = onVersionClick?.(file);
      closeForm(formId);
      return !!result;
    },
    [onVersionClick, closeForm, formId],
  );

  return <VersionsList onVersionClick={onClick} {...restProps} />;
};
